import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdateAnnouncementRes;
export const addUpdateAnnouncementTodo = createAsyncThunk('addUpdateAnnouncement', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/add_update_announcement',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "announcment_id": data.id ? data.id : '',
                "announcement_title": data.title,
                "description": data.description,
                "department_name": data.department
                // .map(val => `${val.value}`).join(',')
                ,
                "status": data.status,
                "created_by": user_id.vemp_code,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdateAnnouncementRes = res.data
    } catch (error) {
        return addUpdateAnnouncementRes = error.response.data
    }
})